import React from 'react';
import { useTranslation } from 'react-i18next';
import FlipCameraIosIcon from '@mui/icons-material/FlipCameraIos';

import IconButton from '@ui-lib/components/IconButton';

interface Props {
	onClick: () => void;
}

export const CameraSwitcher = ({ onClick }: Props) => {
  const { t } = useTranslation();

  return (
    <IconButton
      title={t('switchCamera')}
      onClick={onClick}
      size='large'
    >
      <FlipCameraIosIcon />
    </IconButton>
  );
};

export default CameraSwitcher;